export default {
  showMap (id) {
    return ''
  },
  toggle () {
    this.isActive = !this.isActive
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/item/resources/methods.js